export const externalLinks = {
  dashboardUrl: 'https://gmelius.io/signup?interest=meeting',
  siteHome: 'https://gmelius.com/?ref=meeting',
  siteLegal: 'https://gmelius.com/legal/?ref=meeting',
  sitePrivacy: 'https://gmelius.com/privacy/?ref=meeting',
  siteTerms: 'https://gmelius.com/terms/?ref=meeting',
  extension: {
    chrome: 'https://chrome.google.com/webstore/detail/dheionainndbbpoacpnopgmnihkcmnkl/?ref=meeting',
    opera: 'https://chrome.google.com/webstore/detail/dheionainndbbpoacpnopgmnihkcmnkl/?ref=meeting',
    safari: 'https://app.gmelius.com/downloads/gmelius.safariextz/?ref=meeting'
  }
}
